import React from "react";
import { callApi } from "../../utils/api";
import { OriginalPresent } from "./ManageOriginalPresent";

interface AllProps {
  selectedOriginalPresent: OriginalPresent;
  listOriginalPresent: any;
}
class AddOriginalPresent extends React.Component<AllProps> {
  state = {
    originalPresentdetail: { id: 0, originalPresent_id: 0, name: "" }
  };
  componentWillReceiveProps(nextState) {
    this.setState({ originalPresentdetail: nextState.selectedOriginalPresent });
  }
  handleChange = (e: any) => {
    const originalPresentdetail: any = this.state.originalPresentdetail;
    originalPresentdetail[e.target.name] = e.target.value;
    this.setState({ originalPresentdetail });
  };
  saveOriginalPresent = () => {
    if (this.state.originalPresentdetail.id) {
      this.state.originalPresentdetail.id = Number(this.state.originalPresentdetail.id);
      callApi("POST", "original_update.php", this.state.originalPresentdetail)
        .then(res => res.data)
        .then(response => {
          this.props.listOriginalPresent();
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      callApi("POST", "original_create.php", this.state.originalPresentdetail)
        .then(res => res.data)
        .then(response => {
          this.props.listOriginalPresent();
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  render() {
    return (
      <div
        className="modal fade"
        id="originalPresent-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">OriginalPresent Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">OriginalPresent Name:</label>{" "}
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Original Present Name"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.originalPresentdetail.name
                        ? this.state.originalPresentdetail.name
                        : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={this.saveOriginalPresent}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddOriginalPresent;
